import React from 'react';
import { STEP_LABELS } from '../constants';
import { Step } from '../types';
import useStyles, { STYLES, mergeStyles } from '../useStyles';

const getStepState = (step: number, currentStep: Step): string => {
	if (step === currentStep) return 'current';
	if (step < currentStep) return 'done';
	return 'upcoming';
};

// Read-only progress indicator; steps are not navigable
const StepRail: React.FC<{ step: Step }> = ({ step: currentStep }) => {
	const { css, classes } = useStyles();
	return (
		<ol aria-label='Progress' className={classes.rail}>
			{STEP_LABELS.map(({ step, label }, index) => {
				const state: string = getStepState(step, currentStep);
				const isCurrent: boolean = state === 'current';
				const isDone: boolean = state === 'done';
				return (
					<li
						key={step}
						aria-current={isCurrent ? 'step' : undefined}
						className={css(
							mergeStyles(STYLES.railItem, isCurrent ? STYLES.railItemCurrent : {}, isDone ? STYLES.railItemDone : {})
						)}>
						{index > 0 && <span aria-hidden='true' className={classes.railDivider} />}
						<span
							aria-hidden='true'
							className={css(
								mergeStyles(
									STYLES.railIndex,
									isCurrent ? STYLES.railIndexCurrent : {},
									isDone ? STYLES.railIndexDone : {}
								)
							)}>
							{isDone ? '✓' : step}
						</span>
						<span>
							{label}
							<span className={classes.srOnly}>{` (step ${step} of ${STEP_LABELS.length}, ${state})`}</span>
						</span>
					</li>
				);
			})}
		</ol>
	);
};

export default StepRail;
